module.exports = __webpack_public_path__ + "img/activ8-iron-on-3.f5f85753.png";